import React from 'react';
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Render from '../Render';
import styles from './BrandCard.module.css';

function BrandCard(props) {
  return (
    <Card 
      variant='outlined'
      className={styles.card_container}
      sx={{ display: 'flex', flexDirection: 'column', minHeight: 200 }}
    >
      <CardActionArea className={styles.card_action_area}>
        <Link href={"/brand/" + props.favorite.name_slug}>
          <CardMedia
            component='img'
            alt={props.favorite.name}
            image={'/brand_images/' + (props.favorite.brand_id || props.favorite.id) + '.jpg'}
            sx={{
              height: props.editable ? 120 : 135, 
              display: 'block', 
              backgroundSize: 'cover', 
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              width: '100%',
              padding: '0em 1em 0px',
              objectFit: 'contain'
            }}
          />
          <CardContent key={props.index}sx={{ paddingBottom: '0px !important',  padding: props.editable ? 0 : 1 }}>
            <Typography
              variant="h5"
              component="div"
              className={styles.name}
            >
              {props.favorite.brand_name || props.favorite.name || 'Unknown Brand'}
            </Typography>
          </CardContent>
        </Link>
      </CardActionArea>
      <CardActions sx={{ marginTop: 'auto', display: 'flex', justifyContent: 'center' }}>
        <Render if={props.editable}>
          <Button 
            onClick={() => props.deleted(props.favorite.brand_id)} 
            sx={{ height: 30, width: 145 }}
            color='secondary'
            variant='outlined'
          >
            <ClearIcon className={styles.icon} />
          </Button>
        </Render>
      </CardActions>
    </Card>
  );
}
export default BrandCard;